import { EntityLinks, Goal } from '@griply/types';
import { getDirectGoalLifeAreaIds } from '@griply/utils';
import { ID } from 'shared/types/id';

import { GoalFormSeed } from './goal-form-context';

// The life areas the form starts with. A create seeded with parents gets none: a nested goal
// inherits its parent's life area, and seeding one writes a direct link it must never have.
export const resolveFormLifeAreaIds = (
  seed: GoalFormSeed | undefined,
  links: EntityLinks,
): ID[] => {
  if (seed?.id) {
    return getDirectGoalLifeAreaIds(seed as Goal, links);
  }

  if (seed?.parentIds?.length) {
    return [];
  }

  return seed?.lifeAreaId ? [seed.lifeAreaId] : [];
};
